import { injectable } from 'inversify';
import { ImportMode } from '../generated/types';
import { TranslationService } from '../services/translationService';
import { CsvInputService } from './csvInput';
import { MappableImportInputService } from './mappableImportInput';

@injectable()
export class DelegationsImportInputService extends MappableImportInputService {
    static override IMPORT_COLUMNS_DEFAULT = {
        ...MappableImportInputService.IMPORT_COLUMNS_DEFAULT,

        /* CreateUpdate key */
        // TODO

        /* Required */
        CategoryName: 'categoryName',
        Name: 'name',
        FormId: 'formId',

        /* Optional */
        Deadline: 'deadline',
        MaxResources: 'maxResources',
        LeadersEmails: 'leadersEmails',
        LeadersFirstNames: 'leadersFirstnames',
        LeadersLastNames: 'leadersLastnames',
        PrivateNote: 'privateNote',
        Tags: 'tags'
    };

    static override IMPORT_COLUMNS_REQUIRED = (mode: ImportMode) => [
        ...(mode === ImportMode.Update
            ? [DelegationsImportInputService.IMPORT_COLUMNS_DEFAULT.Id]
            : []),
        ...[
            DelegationsImportInputService.IMPORT_COLUMNS_DEFAULT.Name,
            DelegationsImportInputService.IMPORT_COLUMNS_DEFAULT.FormId
        ]
    ];

    // Needed to stop 'The number of constructor arguments in the derived class VolunteersImportInputService must be >= than the number of constructor arguments of its base class' errors
    constructor(
        protected override csvInputService: CsvInputService,
        translationService: TranslationService
    ) {
        super(csvInputService, translationService);
    }
}
